import React from 'react'
import hours from '../assets/24-7.png';
import quickSupport from '../assets/quick-support.png';
import thumbsup from '../assets/thumb-up.png';
import { MdOutlinePhone } from "react-icons/md";
import { motion } from "framer-motion";
const Support = () => {
  return (
    <div className="my-10" name="support">
        <motion.h2 className="text-4xl text-center text-blue-950 font-semibold font-poppins m-4" initial={{ y: 50, opacity: 0 }}
  whileInView={{ y: 0, opacity: 1 }}
  transition={{ duration: 1 }}>Support</motion.h2>
        <div className="ml-5 mr-5 flex flex-col justify-around items-center gap-4 lg:grid lg:grid-cols-4 lg:items-stretch p-4">
            <motion.div initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, ease: "easeOut" }}
>
                <h2 className="text-xl font-medium mb-4 font-inter text-cyan-900">We are always here to support you.</h2>
                <p className="font-roboto">Customer satisfaction is what we believe the most. We are always open to provide quality services and support to our customers for the better experience.</p>
                <div className="flex items-center gap-2 mt-4">
                <MdOutlinePhone className="text-blue-950" size={25}/><p className="text-blue-950 font-roboto">9472652042</p> 
                 </div>        
            </motion.div>
            <motion.div initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.2, ease: "easeOut" }}
 className="flex flex-col items-center border-2 border-gray-400 rounded-sm shadwo-lg bg-gradient-to-r from-gray-100 to-gray-200 p-3 h-full">
                <img src={hours}  className="w-12 h-12" alt="support" loading="lazy"/>
                <h2 className="text-2xl">24/7 Support</h2>
                <p className="font-roboto">We are always open when it comes to providing service to our customers.We provide 24/7 support to our customer for any kind of issues in order to maintain the quality internet experience.</p>
            </motion.div>
            <motion.div initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.2, ease: "easeOut" }}
     className="flex flex-col items-center border-2 border-gray-400 rounded-sm shadwo-lg bg-gradient-to-r from-gray-100 to-gray-200 p-3 h-full">
                <img src={quickSupport}  className="w-12 h-12" loading="lazy" alt="quick Support"/>
                <h2 className="text-2xl">Quick Service</h2>
                <p className="font-roboto">Depending upon the need and requirement we provide both phone and field support as per the requirement of the customers.</p>
            </motion.div>
            <motion.div initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.2, ease: "easeOut" }}
     className="flex flex-col items-center border-2 border-gray-400 rounded-sm shadwo-lg bg-gradient-to-r from-gray-100 to-gray-200 p-3 h-full">
                <img src={thumbsup} alt="image3" className="w-10 h-12" loading='lazy'/>
                <h2 className="text-2xl">Trained quality staff</h2>
                <p className='font-roboto'>We do not compomise in providing quality service to our customers. We have deft and trained staff to resolve variety of technical and non-technical issues faced by our customer.</p>
            </motion.div>
    </div>
    </div>
  )
}

export default Support